import { isEqual, compact } from 'underscore';

import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import {
  filterImageIdsToRemove,
  getUpdatedPages,
  getUpdateImages,
  getComponentByType,
  COMPONENT_TYPE_MAPPING,
} from '@bingads-webui-campaign-react/smart-component-util';

export const siteConfigReducer = (state, action) => {
  const newState = { ...state };

  switch (action.type) {
    case 'UPDATE_DATASOURCE_BY_NAME': {
      const { name, value } = action.payload;

      newState.dataSource = {
        ...state.dataSource,
        [name]: value,
      };
      break;
    }
    case 'UPDATE_WEBSITESOURCEDATA_BY_NAME': {
      const { name, value } = action.payload;

      newState.websiteSourceData = {
        ...state.websiteSourceData,
        [name]: value,
      };
      break;
    }
    case 'UPDATE_SITE_CONFIG': {
      const {
        dataSource,
        pages,
        theme,
        images,
        snapshots,
        status,
        smartPageDataContext,
        subDomain,
        siteContextInfo,
        orderedComponentsInPages,
        websiteSourceData,
        migrationContext,
        forceUpdate,
        associations,
      } = action.payload;
      if (!isEqual(newState.dataSource, dataSource)) {
        newState.dataSource = cloneDeep(dataSource);
      }
      if (!isEqual(newState.pages, pages) || forceUpdate) {
        newState.pages = cloneDeep(pages);
      }
      if (!isEqual(newState.theme, theme)) {
        newState.theme = cloneDeep(theme);
      }
      if (!isEqual(newState.images, images)) {
        newState.images = compact(cloneDeep(images));
      }
      if (!isEqual(newState.snapshots, snapshots)) {
        newState.snapshots = cloneDeep(snapshots);
      }
      if (!isEqual(newState.status, status)) {
        newState.status = status;
      }
      if (!isEqual(newState.smartPageDataContext, smartPageDataContext)) {
        newState.smartPageDataContext = cloneDeep(smartPageDataContext);
      }
      if (!isEqual(newState.subDomain, subDomain)) {
        newState.subDomain = subDomain;
      }
      if (!isEqual(newState.siteContextInfo, siteContextInfo)) {
        newState.siteContextInfo = siteContextInfo;
      }
      if (!isEqual(newState.orderedComponentsInPages, orderedComponentsInPages)) {
        newState.orderedComponentsInPages = orderedComponentsInPages;
      }
      if (!isEqual(newState.websiteSourceData, websiteSourceData)) {
        newState.websiteSourceData = cloneDeep(websiteSourceData);
      }
      if (!isEqual(newState.migrationContext, migrationContext)) {
        newState.migrationContext = cloneDeep(migrationContext);
      }
      if (!isEqual(newState.associations, associations)) {
        newState.associations = cloneDeep(associations);
      }

      break;
    }
    case 'UPDATE_PAGE': {
      const {
        page,
        pageIndex,
      } = action.payload;
      const newPage = cloneDeep(page);
      const newPages = cloneDeep(newState.pages);
      newPages[pageIndex] = newPage;
      newState.pages = newPages;
      break;
    }
    case 'UPDATE_ORDERED_COMPONENTS': {
      newState.orderedComponentsInPages = [...action.payload];
      break;
    }
    case 'UPDATE_COMPONENT_BY_ID': {
      newState.pages = getUpdatedPages(state.pages, action.payload);
      break;
    }
    case 'UPDATE_SITE_CONFIG_BY_TYPE': {
      const { type, value } = action.payload;

      const config = getComponentByType(state, type);
      const updatedConfig = {
        ...config,
        ...value,
      };
      newState.pages = getUpdatedPages(state.pages, updatedConfig);
      break;
    }
    case 'UPDATE_COVER_IMAGE': {
      const coverImageConfig = getComponentByType(state, COMPONENT_TYPE_MAPPING.CoverImage);
      const updatedConfig = {
        ...coverImageConfig,
        ...action.payload,
      };

      if (!isEqual(updatedConfig, coverImageConfig)) {
        newState.pages = getUpdatedPages(state.pages, updatedConfig);
      }
      break;
    }
    case 'UPDATE_TAG': {
      const { type, id } = action.payload;

      newState.uetTagId = id;
      newState.isMTagMigrated = type === 'UET';

      break;
    }
    case 'UPDATE_IMAGES': {
      const { imageIdsToRemove, imagesToAdd } = action.payload;
      const finalImageIdsToRemove = filterImageIdsToRemove(newState, imageIdsToRemove);
      newState.images = getUpdateImages(
        state.images,
        state.snapshots.images,
        compact(finalImageIdsToRemove),
        compact(imagesToAdd)
      );
      break;
    }
    case 'UPDATE_LOCAL_IMAGE_URL': {
      newState.localImageUrl = action.payload;
      break;
    }
    case 'DELETE_COMPONENT': {
      const {
        components,
        orderedComponents,
        websiteSourceData,
        pageIndex,
      } = action.payload;
      const pages = [...newState.pages];
      pages[pageIndex].components = [...components];
      newState.pages = pages;
      newState.orderedComponentsInPages = [...orderedComponents];
      newState.websiteSourceData = { ...websiteSourceData };
      break;
    }
    case 'ADD_COMPONENT': {
      const { components, orderedComponents, pageIndex } = action.payload;
      const pages = [...newState.pages];
      pages[pageIndex].components = [...components];
      newState.pages = pages;
      newState.orderedComponentsInPages[pageIndex] = [...orderedComponents];
      break;
    }
    case 'UPDATE_SITE_STATUS': {
      newState.status = action.payload;
      break;
    }
    case 'UPDATE_SITE_CONTEXT_INFO': {
      newState.siteContextInfo = {
        ...state.siteContextInfo,
        ...action.payload,
      };
      break;
    }
    case 'UPDATE_WSD_MIGRATION_STATUS': {
      newState.migrationContext = {
        ...state.migrationContext,
        ...action.payload,
      };
      break;
    }
    default:
      throw new Error();
  }

  return newState;
};
